import { Card, CardHeader, CardBody, Form, Input, Label, Button, FormGroup, Row, Col } from "reactstrap";
import DatePicker from "react-datepicker";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { anonymousUtils } from "../../../portal/anonymous.utils";
import sessionUtils from "../../sessions/sessionsutils";
import { HomeSessionCard } from "./HomeSessionCard";
import errorImg from "../../../assets/images/search-not-found.png";

export function HomeSessionsListCard() {

    const [listasessioni, setListaSessioni] = useState([]);
    const [, setIsLoading] = useState(false);
    const [odg, setOdg] = useState('');
    const [oratore, setOratore] = useState('');
    const [numseduta, setNumSeduta] = useState('');
    const [searchtext, setSearchtext] = useState('');
    const [datada, setDataDa] = useState(null);
    const [dataa, setDataA] = useState(null);
    const [layoutColumns,] = useState(3);
    const [filterSidebar,] = useState(true);
    const [sidebaron, setSidebaron] = useState(true);

    useEffect(() => {
        resetStorage();
        loadSessioni({ size: 12 });
    }, []);

    const onClickFilter = () => {
        try {
            if (sidebaron) {
                setSidebaron(false);
                document.querySelector(".product-wrapper").classList.add("sidebaron");
            } else {
                setSidebaron(true);
                document.querySelector(".product-wrapper").classList.remove("sidebaron");
            }
        } catch (e) {

        }

    };



    const resetStorage = () => {
        localStorage.removeItem('id');
        localStorage.removeItem('session_token');
        localStorage.removeItem('id');
        localStorage.removeItem('rl');
        localStorage.removeItem('session_expire');
        localStorage.removeItem('username');
        localStorage.removeItem('Name');
        localStorage.removeItem('grp');
    }



    async function loadElasticSearchSession({ size }) {
        setIsLoading(true);
        const typeTagsSearch = [];

        if ((oratore && oratore !== '')) {
            typeTagsSearch.push({
                type: 'ORATORE',
                tags: [oratore]
            });
        }
        if ((odg && odg !== '')) {
            typeTagsSearch.push({
                type: 'ODG',
                tags: [odg]
            });
        }
        if ((numseduta && numseduta !== '')) {
            typeTagsSearch.push({
                type: 'NUMEROSESSIONE',
                tags: [numseduta]
            });
        }
        if ((document.getElementById('fasedellasedutaselect').value !== '')) {
            typeTagsSearch.push({
                type: 'FASESEDUTA',
                tags: [document.getElementById('fasedellasedutaselect').value]
            });
        }
        const queryobject = anonymousUtils.searchSessionParamsTypeTags({
            roleType: 'ANONYMOUS',
            typeTags: typeTagsSearch,
            fromDate: datada ? datada : null,
            toDate: dataa ? dataa : null,
            toString: true,
            term: searchtext,
            size
        });

        console.log(queryobject);
        try {
            const search = await sessionUtils.methods.queryElasticSearch(queryobject, true);
            const searchResponse = search.payload;
            console.log('SEARCH: ', searchResponse);
            const resultlist = [];
            if (searchResponse.length > 0) {
                for (let i = 0; i < searchResponse.length; i++) {

                    let id = -1;
                    let numsessione = -1;
                    for (let z = 0; z < searchResponse[i].videoItem.typeTags.length; z++) {
                        if (searchResponse[i].videoItem.typeTags[z]?.type === 'ID')
                            id = searchResponse[i].videoItem.typeTags[z].tags[0];
                        if (searchResponse[i].videoItem.typeTags[z]?.type === 'NUMEROSESSIONE')
                            numsessione = searchResponse[i].videoItem.typeTags[z].tags[0];
                    }

                    const record = {
                        deleted: false,
                        description: searchResponse[i].videoItem.description,
                        id: id,
                        idGroup: searchResponse[i].videoItem.groupId,
                        idStato: 1,
                        linkTrascrizione: searchResponse[i].videoItem.transcriptionURL,
                        linkVideo: searchResponse[i].videoItem.videoURL,
                        name: searchResponse[i].videoItem.name,
                        numeroSessione: numsessione,
                        timenote: searchResponse[i].videoItem.timenote,
                        timestamp: new Date(searchResponse[i].date),
                        noTranscription: searchResponse[i].videoItem.transcriptionURL === 'MOCKED_URL',
                    };

                    resultlist.push(record);
                }
            }

            setListaSessioni(resultlist);
            setIsLoading(false);
            return resultlist;

        } catch (e) {
            setIsLoading(false);
            toast.error('Qualcosa è andato storto');
        }
    }

    async function loadSessioni({ e, size }) {
        e && e.preventDefault();
        loadElasticSearchSession({ size });
    }
    return (<Card>
        <CardBody>

            <div className="product-grid">
                <div className="feature-products">

                    <Form onSubmit={e => loadSessioni({ e })}>

                        <Row>
                            <Col sm="3">
                                <div
                                    className={`product-sidebar ${filterSidebar ? "" : "open"}`}
                                >
                                    <div className="filter-section">
                                        <Card>
                                            <CardHeader>
                                                <h6 className="mb-0 f-w-600">
                                                    Filtri avanzati
                                                    <span className="pull-right">
                                                        <i
                                                            className="fa fa-chevron-down toggle-data"
                                                            onClick={onClickFilter}
                                                        />
                                                    </span>
                                                </h6>
                                            </CardHeader>
                                            <div className="left-filter">
                                                <CardBody className="filter-cards-view animate-chk"
                                                    style={{ margin: 0, padding: '5px' }}>

                                                    <Col xl="12">

                                                        <div className="job-filter">
                                                            <Label>Oratore</Label>

                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder=""
                                                                value={oratore}
                                                                onChange={(e) => {
                                                                    setOratore(e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="job-filter">
                                                            <Label>Numero Seduta</Label>
                                                            {/* <div className="faq-form"> */}
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder=""
                                                                value={numseduta}
                                                                onChange={(e) => {
                                                                    setNumSeduta(e.target.value)
                                                                }}
                                                            />

                                                        </div>
                                                        <br />
                                                        <div className="job-filter">
                                                            <Label>Fase della Seduta</Label>
                                                            <select id="fasedellasedutaselect" className="form-control btn-pill"
                                                                size="1">
                                                                <option value=''>Seleziona</option>
                                                                <option value="nessuna">Nessuna</option>
                                                                <option value="annunci">Annunci</option>
                                                                <option value="sospensioni">Sospensioni</option>
                                                            </select>
                                                        </div>
                                                        <br />
                                                        <div className="job-filter">
                                                            <Label>ODG</Label>
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder=""
                                                                value={odg}
                                                                onChange={(e) => {
                                                                    setOdg(e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <br />


                                                    </Col>
                                                </CardBody>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </Col>
                            <Col xl="9" sm="12">
                                <Row>
                                    <Col sm="4">
                                        <FormGroup className="m-0">
                                            <Input
                                                className="form-control"
                                                type="text"
                                                placeholder="Cerca"
                                                defaultValue={searchtext}
                                                onChange={(e) => setSearchtext(e.target.value)}
                                            />
                                            <i className="fa fa-search" onClick={e => loadSessioni({ e })}
                                               style={{ cursor: 'pointer', color: 'var(--primary-color)' }} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="3">
                                        <FormGroup className="m-0">
                                            <DatePicker
                                                className="form-control digits"
                                                id='input_datada_sessione'
                                                selected={datada}
                                                onChange={(e) => {
                                                    setDataDa(e)
                                                }}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Data da"
                                            />
                                            <i className="fa fa-calendar" />
                                        </FormGroup>

                                    </Col>
                                    <Col sm="3">
                                        <FormGroup className="m-0">
                                            <DatePicker
                                                className="form-control digits"
                                                id='input_dataa_sessione'
                                                selected={dataa}
                                                onChange={(e) => {
                                                    setDataA(e)
                                                }}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Data a"
                                            /> <i className="fa fa-calendar" />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="2" style={{ paddingTop: '10px' }}>
                                        <Button type="submit" color="primary" className="text-center"
                                            style={{ width: '100%', margin: 'auto' }}>Cerca</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                    {/* Product sidebar  end*/}
                </div>
                {/* Product list  start*/}
                <div className="product-wrapper-grid">
                    {!listasessioni.length ? (
                        <div className="search-not-found text-center">
                            <div>
                                <img
                                    className="img-fluid second-search"
                                    src={errorImg}
                                    alt=""
                                />
                                <p>Non ci sono risultati per la ricerca effettutata</p>
                            </div>
                        </div>
                    ) : (
                        <Row className="gridRow">
                            {
                                listasessioni?.map((item, i) => (
                                    <div
                                        className={`${layoutColumns === 3
                                            ? "col-xl-3 col-sm-6 xl-4 col-grid-box"
                                            : "col-xl-" + layoutColumns
                                            }`}
                                        key={i}
                                    >
                                        <HomeSessionCard
                                            {...item}
                                            url={`/sessions/view?id=${item.id}`}
                                            imageUrl='/images//video_icon2.png'
                                        />
                                    </div>
                                ))
                            }
                        </Row>
                    )}
                </div>
            </div>
        </CardBody>
    </Card>
    );
}
